import Nullstack from 'nullstack';
export default function IconTiltShiftOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tilt-shift-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8.56 3.69a9 9 0 0 0 -.577 .263"
  }), "   ", Nullstack.element("path", {
    d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
  }), "   ", Nullstack.element("path", {
    d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
  }), "   ", Nullstack.element("path", {
    d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
  }), "   ", Nullstack.element("path", {
    d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
  }), "   ", Nullstack.element("path", {
    d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
  }), "   ", Nullstack.element("path", {
    d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
  }), "   ", Nullstack.element("path", {
    d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
  }), "   ", Nullstack.element("path", {
    d: "M10.57 10.602a2 2 0 0 0 2.862 2.795"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}